<div class="form-group" *ngFor="let customer of membership.all_customers">
  <label *ngIf="membership.is_group">{{ customer.first_name }} {{ customer.last_name }}</label>
  <div class="form-check" *ngFor="let addOn of membership.customer_add_on_options">
    <input class="form-check-input" type="checkbox"
           id="add-on-input-{{ customer.id.toString() }}-{{ addOn.id }}"
           [checked]="addOnIsSelectedForCustomer(customer, addOn)"
           (change)="toggleAddOnForCustomer(customer, addOn)">
    <label class="form-check-label"
           for="add-on-input-{{ customer.id.toString() }}-{{ addOn.id }}">
      {{ addOn.name }} ({{ orgConfig.getCurrencySymbol() }}{{ addOn.fee }})
    </label>
  </div>
</div>

<p>
  The add-ons will take effect at the next bill date.
</p>

<div class="alert alert-warning" role="alert" *ngIf="membershipHasPendingAddOnChanges()">
  This membership already has add-on changes which will take effect at the next bill date. These changes will replace the previous changes.
</div>

<div class="alert alert-danger" role="alert" *ngIf="errorMessage">
  {{ errorMessage }}
</div>
